<div class="container loginContainer">
  <div class="col-md-12">
    <!-- verify section -->
    @if (false) {
      <div>
        @if (showVerifyForm === "verify") {
          <div class="card lgFrmCard login-verify-card">
            <p class="text-center verify-heading">
              <b>Please confirm your email</b>
            </p>
            <p class="text-center">
              We've sent an OTP to your Email and Mobile
            </p>
            <div class="form-group">
              <label for="" class="form-label mandatoryLabel"
                >OTP <i class="fa-solid fa-asterisk mandatoryIcon"></i
              ></label>
              <div class="input-field">
                <input
                  id="otp"
                  name="otp"
                  #verifyOTP
                  [(ngModel)]="otpInput"
                  [ngModelOptions]="{ standalone: true }"
                  class="form-control"
                  type="text"
                  placeholder="Enter your PIN"
                />
              </div>
              <div class="text-danger" #verifyOTPError>Enter valid PIN</div>
            </div>
            <button
              class="btn btn-primary signInBtn"
              type="button"
              #verifyOTPBtn
              (click)="submitOtp()"
              (keydown.enter)="submitOtp()"
            >
              @if (spinner) {
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw">
                  <span class="sr-only">Loading...</span>
                </i>
              }
              Verify
            </button>
            <p class="ReturnLoginTxt text-center">
              <a
                class="returnClass"
                (click)="goBack()"
                (keydown.enter)="goBack()"
                >Return to Log in</a
              >
            </p>
          </div>
        }
      </div>
    }
    @if (showVerifyForm === "verify") {
      <div class="card lgFrmCard login-verify-card">
        <p class="text-center verify-heading">
          <b>Please confirm your email</b>
        </p>
        <p class="text-center">We've sent an OTP to your Email and Mobile</p>
        <div class="form-group">
          <label for="" class="form-label mandatoryLabel"
            >OTP
            <i class="fa-solid fa-asterisk mandatoryIcon"></i>
          </label>
          <div class="input-field">
            <input
              id="otp"
              name="otp"
              #verifyOTP
              [(ngModel)]="otpInput"
              [ngModelOptions]="{ standalone: true }"
              class="form-control"
              type="text"
              placeholder="Enter your PIN"
            />
          </div>
          <div class="text-danger" #verifyOTPError>Enter valid PIN</div>
        </div>
        <!-- ── CAPTCHA BLOCK ───────────────────────────────────── -->
        <div class="form-group captcha-group">
          <label for="" class="form-label">Verify you are human</label>
          <div class="captcha-row">
            <div class="captcha-canvas-wrap">
              <canvas id="captchaCanvas" width="180" height="44"></canvas>
            </div>
            <button
              type="button"
              class="captcha-refresh-btn"
              (click)="generateCaptcha()"
              (keydown.enter)="generateCaptcha()"
              title="Refresh"
              aria-label="Refresh CAPTCHA"
            >
              <i class="fa fa-refresh"></i>
            </button>
          </div>
          <div class="input-field">
            <input
              class="form-control"
              type="text"
              maxlength="6"
              placeholder="Case-sensitive, enter exactly as shown"
              [(ngModel)]="captchaInput"
              [ngModelOptions]="{ standalone: true }"
              (input)="verifyCaptcha()"
              autocomplete="off"
            />
          </div>
          @if (captchaSubmitted && !captchaVerified) {
            <span class="text-danger">
              Incorrect characters. Please try again.
            </span>
          }
        </div>
        <!-- ──────────────────────────────────────────────────────── -->
        <button
          class="btn btn-primary signInBtn"
          type="button"
          #verifyOTPBtn
          (click)="submitOtp()"
          (keydown.enter)="submitOtp()"
        >
          @if (spinner) {
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw">
              <span class="sr-only">Loading...</span>
            </i>
          }
          Verify
        </button>
        <p class="ReturnLoginTxt text-center">
          <a class="returnClass" (click)="goBack()" (keydown.enter)="goBack()"
            >Return to Log in</a
          >
        </p>
      </div>
    }
    <!-- otp form section -->
    @if (showVerifyForm === "otp") {
      <form [formGroup]="passwordForm">
        <div class="card lgFrmCard login-verify-card">
          <p class="text-center verify-heading">
            <b>{{ signup_verified ? "Create Password" : "Reset Password" }}</b>
          </p>
          <div class="form-group">
            <label
              for=""
              class="form-label mandatoryLabel"
              [ngClass]="{ 'is-invalid': submitted && f['password'].errors }"
              >New Password<i class="fa-solid fa-asterisk mandatoryIcon"></i
            ></label>
            <div class="input-field">
              <input
                class="form-control"
                [type]="type"
                formControlName="password"
                id="password"
                name="password"
              />
              <span
                class="fa {{ eyeIcon }} passwordEye"
                (click)="hideShowPassword()"
                (keydown.enter)="hideShowPassword()"
                (keydown.space)="hideShowPassword()"
              ></span>
            </div>
            @if (submitted && f["password"].errors) {
              <div class="invalid-feedback text-danger">
                @if (f["password"].errors["required"]) {
                  <div class="text-danger">New Password is required</div>
                }
                @if (f["password"].errors["pattern"]) {
                  <div class="text-danger">
                    Password must be at least 8 characters, and include at least
                    1 number and 1 special character (eg. _, &#64;, or $).
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <label for="" class="form-label mandatoryLabel"
              >Confirm Password<i class="fa-solid fa-asterisk mandatoryIcon"></i
            ></label>
            <input
              type="password"
              formControlName="confirmPassword"
              class="form-control"
              [ngClass]="{
                'is-invalid': submitted && f['confirmPassword'].errors,
              }"
            />
            @if (submitted && f["confirmPassword"].errors) {
              <div class="invalid-feedback text-danger">
                @if (f["confirmPassword"].errors["required"]) {
                  <div class="text-danger">Confirm Password is required</div>
                }
                @if (f["confirmPassword"].errors["matching"]) {
                  <div class="text-danger">
                    Confirm Password doesn't match.Please re-enter your
                    password.
                  </div>
                }
              </div>
            }
          </div>
          <button
            class="btn btn-primary signInBtn"
            type="button"
            (click)="onSubmit()"
            (keydown.enter)="onSubmit()"
          >
            @if (spinner) {
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw">
                <span class="sr-only">Loading...</span>
              </i>
            }
            {{ signup_verified ? "Create Password" : "Reset Password" }}
          </button>
          <p class="ReturnLoginTxt text-center">
            <a class="returnClass" (click)="goBack()" (keydown.enter)="goBack()"
              >Back to Log in</a
            >
          </p>
        </div>
      </form>
    }
    <!-- password updated success fully -->
    @if (showVerifyForm === "passwordSuccess") {
      <div class="card lgFrmCard login-verify-card">
        <p class="text-center verify-heading">
          <b>Password Created SuccessFully</b>
        </p>
        <div class="col-md-3 offset-md-4">
          <button
            class="btn btn-primary signInBtn passwordSuccessBtn"
            type="button"
            (click)="goBack()"
            (keydown.enter)="goBack()"
          >
            Return to Login
          </button>
        </div>
      </div>
    }
  </div>
</div>
